export { default as StrategyMapHeaderInfoTag } from './StrategyMapHeaderInfoTag';
